export enum AdesaoSaudeEnum {
    FILHOS_ENTEADOS_24ANOS_INCOMPLETOS = 1,
    FILHOS_ENTEADOS_24ANOS_39ANOS_INCOMPLETOS = 2,
    MENOR_SOB_GUARDA = 3,
    COMPANHEIRO = 4,
    CONJUGE = 5,
    TITULAR = 6,
}
